import { cpAuthPackageStateKeys, spAuthPackageStateKeys } from './auth-package-state.locs';
import { cpBadgeTypeKeys, spBadgeTypeKeys } from './badge-type.locs';
import { cpBcatGrantTypeKeys, spBcatGrantTypeKeys } from './bcat-grant-type.locs';
import { cpBcatTypeKeys, spBcatTypeKeys } from './benefit-catalog-type.locs';
import { cpBenefitStatusKeys, spBenefitStatusKeys } from './benefit-status.locs';
import {
	cpWuserCandRestrictTypeKeys,
	spWuserCandRestrictTypeKeys,
} from './cand-restrict-type.locs';
import { cpCateidTypeKeys, spCateidTypeKeys } from './cateid-type.locs';
import { cpCcatExtensionTypeKeys, spCcatExtensionTypeKeys } from './ccat-extension-type.locs';
import { cpCcatPathTypeKeys, spCcatPathTypeKeys } from './ccat-path-type.locs';
import { cpCertCatalogStatusKeys, spCertCatalogStatusKeys } from './cert-catalog-status.locs';
import { cpCertStatusKeys, spCertStatusKeys } from './cert-status.locs';
import { spCfcRuleKeys } from './cfc-rule.locs';
import { cpChTypeKeys, spChTypeKeys } from './ch-type.locs';
import { cpCprStateKeys, spCprStateKeys } from './cpr-state.locs';
import { cpCprTypeKeys, spCprTypeKeys } from './cpr-type.locs';
import { cpCrcatTypeKeys, spCrcatTypeKeys } from './crcat-type.locs';
import { cpCReqReviewStateKeys, spCReqReviewStateKeys } from './creq-review-state.locs';
import { cpCreqStatusKeys, spCreqStatusKeys } from './creq-status.locs';
import {
	cpEligibleExamActionTypeKeys,
	spEligibleExamActionTypeKeys,
} from './eligible-exam-action-type.locs';
import { cpExamGradeLabelKeys, spExamGradeLabelKeys } from './exam-grade-label.locs';
import { cpExamStateKeys, spExamStateKeys } from './exam-state.locs';
import { cpExamViolationTypeKeys, spExamViolationTypeKeys } from './exam-violation-type.locs';
import { cpExapReviewStateKeys, spExapReviewStateKeys } from './exap-review-state.locs';
import { cpFcatQueueTypeKeys, spFcatQueueTypeKeys } from './fcat-queue-type.locs';
import { cpFulfillmentStatusKeys, spFulfillmentStatusKeys } from './fulfillment-status.locs';
export { cpBcatGrantTypeKeys, spBcatGrantTypeKeys } from './bcat-grant-type.locs';
export { cpBcatTypeKeys, spBcatTypeKeys } from './benefit-catalog-type.locs';
export {
	cpWuserCandRestrictTypeKeys,
	spWuserCandRestrictTypeKeys,
} from './cand-restrict-type.locs';
export { cpCateidTypeKeys, spCateidTypeKeys } from './cateid-type.locs';
export { cpCertStatusKeys, spCertStatusKeys } from './cert-status.locs';
export { cpChTypeKeys, spChTypeKeys } from './ch-type.locs';
export { cpCReqReviewStateKeys, spCReqReviewStateKeys } from './creq-review-state.locs';
export {
	cpETransactionItemCatTypeKeys,
	spETransactionItemCatTypeKeys,
} from './e-transaction-item-cat-type.locs';
export { cpETransactionStateKeys, spETransactionStateKeys } from './e-transaction-state.locs';
export { cpExauthStateKeys, spExauthStateKeys } from './ex-auth-state.locs';
export { cpExamGradeLabelKeys, spExamGradeLabelKeys } from './exam-grade-label.locs';
export { cpFcatQueueTypeKeys, spFcatQueueTypeKeys } from './fcat-queue-type.locs';
export { cpFulfillmentStatusKeys, spFulfillmentStatusKeys } from './fulfillment-status.locs';

export const GLOBAL_ENUM_KEYS = {
	cpCertStatus: cpCertStatusKeys,
	spCertStatus: spCertStatusKeys,
	cpExamGradeLabel: cpExamGradeLabelKeys,
	spExamGradeLabel: spExamGradeLabelKeys,
	cpExamState: cpExamStateKeys,
	spExamState: spExamStateKeys,
	cpBenefitStatus: cpBenefitStatusKeys,
	spBenefitStatus: spBenefitStatusKeys,
	cpCcatExtensionType: cpCcatExtensionTypeKeys,
	spCcatExtensionType: spCcatExtensionTypeKeys,
	cpCcatPathType: cpCcatPathTypeKeys,
	spCcatPathType: spCcatPathTypeKeys,
	cpBadgeType: cpBadgeTypeKeys,
	spBadgeType: spBadgeTypeKeys,
	cpBcatType: cpBcatTypeKeys,
	spBcatType: spBcatTypeKeys,
	cpBcatGrantType: cpBcatGrantTypeKeys,
	spBcatGrantType: spBcatGrantTypeKeys,
	cpFcatQueueType: cpFcatQueueTypeKeys,
	spFcatQueueType: spFcatQueueTypeKeys,
	cpCertCatalogStatus: cpCertCatalogStatusKeys,
	spCertCatalogStatus: spCertCatalogStatusKeys,
	cpEligibleExamActionType: cpEligibleExamActionTypeKeys,
	spEligibleExamActionType: spEligibleExamActionTypeKeys,
	cpCateidType: cpCateidTypeKeys,
	spCateidType: spCateidTypeKeys,
	cpFulfillmentStatus: cpFulfillmentStatusKeys,
	spFulfillmentStatus: spFulfillmentStatusKeys,
	cpCReqReviewState: cpCReqReviewStateKeys,
	spCReqReviewState: spCReqReviewStateKeys,
	cpCrcatType: cpCrcatTypeKeys,
	spCrcatType: spCrcatTypeKeys,
	cpCreqStatus: cpCreqStatusKeys,
	spCreqStatus: spCreqStatusKeys,
	cpCprType: cpCprTypeKeys,
	spCprType: spCprTypeKeys,
	cpCprState: cpCprStateKeys,
	spCprState: spCprStateKeys,
	cpChType: cpChTypeKeys,
	spChType: spChTypeKeys,
	spCfcRule: spCfcRuleKeys,
	cpWuserCandRestrictType: cpWuserCandRestrictTypeKeys,
	spWuserCandRestrictType: spWuserCandRestrictTypeKeys,
	cpExamViolationType: cpExamViolationTypeKeys,
	spExamViolationType: spExamViolationTypeKeys,
	cpAuthPackageState: cpAuthPackageStateKeys,
	spAuthPackageState: spAuthPackageStateKeys,
	cpExapReviewState: cpExapReviewStateKeys,
	spExapReviewState: spExapReviewStateKeys,
};
